import { Component, Input, OnInit } from "@angular/core";
import {Store} from "../../services/store.service";

@Component({
  selector: "user-level",
  templateUrl: "./user-level.component.html",
  styleUrls: ["./user-level.component.scss"],
})
export class UserLevelComponent {

  @Input() public page: string;
  @Input() public levelLabel: string;
  public level: number;

  constructor( private store: Store ) { }

  public ngAfterViewInit() {
    setTimeout(() => {
      if (this.store.state.common.userLevels.get(this.page) === false) {
        this.store.state.common.userLevels.pages[this.page] = 1;
        this.level = 1;
      } else {
        this.store.state.common.userLevels.pages[this.page] = this.store.state.common.userLevels.get(this.page);
        this.level = this.store.state.common.userLevels.get(this.page);
      }
    });
  }

  public setLevel(lvl) {
    this.store.state.common.userLevels.pages[this.page] = lvl;
    this.store.state.common.userLevels.set(this.page, lvl);
    this.level = lvl;
  }

}
